import { Box } from '@qga/roo-ui/components';
import withProps from '@/components/withProps';

const Body = withProps({
  flex: '1',
  overflow: 'auto',
})(Box);

export default Body;
